export default __webpack_public_path__ + "static/media/about-2.bc6ee2a2.jpg";